import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../../hook/useAuth";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../../../config/api";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import useConfirm from "../../../../hook/useConfirm";
import useDelete from "../../../../hook/useDelete";


export const EditTerminal = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const idNumber = useLocation();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [name, setName] = useState<string>("");
    const [locationId, setLocationId] = useState<string>("");
    const [ipAddress, setIpAddress] = useState<string>("");
    const [deviceId, setDeviceId] = useState<string>("");
    const [isActive, setIsActive] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        setPleaseWaitPopup(true);
        axios
            .get(`${baseURL}terminalDevices/${idNumber?.state}`)
            .then((response) => {
                setName(response?.data?.name);
                setLocationId(response?.data?.locationId);
                setIpAddress(response?.data?.ipAddress);
                setDeviceId(response?.data?.terminalDeviceId);
                setIsActive(response?.data?.isActive);
                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        await axios
            .put(
                `${baseURL}terminalDevices?userId=${auth?.id}`,
                JSON.stringify({
                    id: idNumber?.state,
                    name,
                    locationId,
                    ipAddress,
                    terminalDeviceId: deviceId,
                    isActive

                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    const deletingTerminal = async () => {
        setDeleteData({
            id: idNumber?.state,
            title: `Delete Terminal`,
            summary: `Are you sure you want to delete this terminal?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();

                axios
                    .delete(`${baseURL}terminalDevices?id=${idNumber?.state}&userId=${auth?.id}`)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        setConfirmData({
                            title: "Warning",
                            summary: error.response?.data || "Delete failed.",
                            confirmBtn: "Ok",
                            isConfirm: (cb: any) => cb(),
                        });

                        setConfirmPopup(true);
                        setPleaseWaitPopup(false);
                    });
            },
        });

        setDeletePopup(true);
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Edit Terminal</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={name}
                                                placeholder="Name"
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">IpAddress</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={ipAddress}
                                                placeholder="IpAddress"
                                                onChange={(e) => setIpAddress(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className={`block text-xs font-medium text-[#667085]`}>IsActive?</label>
                                            <RadioGroup
                                                row
                                                value={isActive ? "Yes" : "No"}
                                                onChange={(e) => setIsActive(e.target.value === "Yes")}
                                            >
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Yes"
                                                    sx={{
                                                        color: "#2f3739",
                                                    }}
                                                />

                                                <FormControlLabel
                                                    value="No"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="No"
                                                    sx={{
                                                        color: "#2f3739",
                                                    }}
                                                />
                                            </RadioGroup>
                                        </div>

                                    </div>

                                    {/* Second Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Location Id</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={locationId}
                                                placeholder="Location Id"
                                                onChange={(e) => setLocationId(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Device Id</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={deviceId}
                                                placeholder="Device Id"
                                                onChange={(e) => setDeviceId(e.target.value)}
                                                required
                                            />
                                        </div>

                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => deletingTerminal()}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-red-500 text-white cursor-pointer border border-red-600"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}